import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { api } from "../lib/api";

const LINKS = [
  { to: "/", label: "Home" },
  { to: "/studio", label: "Studio" },
  { to: "/gear", label: "Gear" },
  { to: "/prev-work", label: "Prev. Work" },
  { to: "/contact", label: "Contact/Book" },
];

export const Header = () => {
  const [open, setOpen] = useState(false);
  const loc = useLocation();

  useEffect(() => setOpen(false), [loc.pathname]);
  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : "";
  }, [open]);

  return (
    <>
      <header className="hdr" data-testid="site-header">
        <div className="wrap hdr-in">
          <Link to="/" className="wordmark" data-testid="nav-wordmark" aria-label="Balboa Recording Studio — home">
            <img
              src="https://res.cloudinary.com/nwvsq3gc/image/upload/f_auto,q_auto,w_500/v1786835277/LOGO_3_FULL.png"
              srcSet="https://res.cloudinary.com/nwvsq3gc/image/upload/f_auto,q_auto,w_300/v1786835277/LOGO_3_FULL.png 300w, https://res.cloudinary.com/nwvsq3gc/image/upload/f_auto,q_auto,w_500/v1786835277/LOGO_3_FULL.png 500w"
              sizes="(max-width: 768px) 180px, 300px"
              alt="Balboa Recording Studio"
            />
          </Link>

          <nav className="tabs only-desk" data-testid="desktop-nav">
            {LINKS.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.to === "/"}
                className={({ isActive }) => `tab${isActive ? " active" : ""}`}
                data-testid={`nav-tab-${l.label.toLowerCase().replace(/[^a-z]+/g, "-").replace(/^-|-$/g, "")}`}
              >
                {l.label}
              </NavLink>
            ))}
          </nav>

          <button
            className="burger only-mob"
            id="burger-btn"
            onClick={() => setOpen(true)}
            data-testid="mobile-menu-open"
            aria-label="Open menu"
          >
            Menu
          </button>
        </div>
      </header>

      {open && (
        <div className="overlay" data-testid="mobile-overlay">
          <div className="overlay-top">
            <span className="label" style={{ color: "var(--paper)" }}>
              Balboa Recording Studio
            </span>
            <button className="overlay-close" onClick={() => setOpen(false)} data-testid="mobile-menu-close">
              Close
            </button>
          </div>
          <nav className="overlay-links">
            {LINKS.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.to === "/"}
                className={({ isActive }) => (isActive ? "active" : "")}
                data-testid={`mobile-link-${l.label.toLowerCase().replace(/[^a-z]+/g, "-").replace(/^-|-$/g, "")}`}
              >
                {l.label}
              </NavLink>
            ))}
          </nav>
        </div>
      )}
    </>
  );
};

export const Footer = () => {
  const [ig, setIg] = useState("@balboarec");
  useEffect(() => {
    api
      .get("/settings")
      .then((r) => r.data?.igHandle && setIg(r.data.igHandle))
      .catch(() => {});
  }, []);
  const handle = ig.replace(/^@/, "");
  return (
    <footer className="ftr grain" data-testid="site-footer">
      <div className="wrap ftr-in">
        <span data-testid="footer-copy">© {new Date().getFullYear()} Balboa Recording Studio · Glassell Park, Los Angeles</span>
        <span style={{ display: "flex", gap: 18, alignItems: "baseline" }}>
          <a
            href={`https://instagram.com/${handle}`}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-instagram"
          >
            {ig}
          </a>
          <Link to="/admin/login" className="ftr-admin" data-testid="footer-admin-link">
            Admin
          </Link>
        </span>
      </div>
    </footer>
  );
};
